var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _g2, _path11, _path12, _path13, _g3, _path14, _g4, _path15, _path16, _g5, _path17, _path18, _g6, _path19, _path20, _g7, _path21, _path22, _g8, _path23, _path24, _g9, _path25, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOsmosis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9358 7.24256C25.6915 6.30174 24.9063 5.36092 23.4927 4.3136C22.3584 3.47928 21.1543 3 20.1945 3C20.0026 3 19.8281 3.01775 19.6536 3.05325C19.2173 3.14201 18.8334 3.46153 18.5891 3.94082C18.2924 4.50886 18.2226 5.27217 18.4146 5.7337C18.4844 5.87571 18.5716 6.05322 18.6763 6.21298C17.7514 6.78102 17.2279 6.94079 17.1581 6.95854C19.5663 7.77509 21.5731 9.47923 22.8296 11.6981L22.8471 11.4851C22.8994 10.8993 23.0739 10.2248 23.3182 9.53248C23.5625 9.60348 23.8069 9.63898 24.0512 9.63898C24.6969 9.63898 25.2552 9.37273 25.6043 8.89344C25.9533 8.41414 26.0929 7.7751 25.9358 7.24256Z",
    fill: "#5E12A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4235 9.0177C25.0115 9.46145 25.6571 8.21886 25.4478 7.38456C25.2209 6.55025 24.488 5.69819 23.1966 4.73962C21.9052 3.78105 20.5965 3.39052 19.7588 3.56803C18.9212 3.74554 18.6768 5.04139 18.8863 5.53843C18.9735 5.73369 19.1655 6.01771 19.4272 6.33723C19.0957 6.568 18.7815 6.74551 18.5198 6.90528C20.1253 7.63308 21.5213 8.76916 22.5684 10.1892C22.6905 9.70999 22.865 9.28395 23.0221 8.91115C23.1442 8.9289 23.2839 8.9644 23.4235 9.0177Z",
    fill: "url(#paint0_radial_4836_27799)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.33 26.4134C19.7175 26.4134 24.085 21.9707 24.085 16.4904C24.085 11.0102 19.7175 6.56747 14.33 6.56747C8.94242 6.56747 4.57495 11.0102 4.57495 16.4904C4.57495 21.9707 8.94242 26.4134 14.33 26.4134Z",
    fill: "url(#paint1_radial_4836_27799)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M24.6447 6.56747C23.3184 5.14737 22.2016 4.77459 20.8579 4.47282C19.8108 4.22431 20.09 3.62076 21.3639 3.74502C20.7532 3.532 20.1773 3.47875 19.7585 3.56751C18.9208 3.74502 18.6765 5.04086 18.8859 5.5379C18.9732 5.73316 19.1651 6.01719 19.4269 6.33671C18.9557 6.65623 18.5543 6.887 18.2228 7.06451C18.3798 7.13551 18.5718 7.22427 18.7987 7.34853C19.392 7.66805 20.0377 8.20057 20.0377 8.20057C19.0604 7.34853 19.2698 6.958 20.6136 5.99943C21.0323 5.69766 21.8002 5.73316 22.5157 6.10594C23.2312 6.47872 24.0688 7.41953 24.0688 7.41953L23.2661 8.98166C23.3184 8.99941 23.3708 9.01716 23.4231 9.03491C23.9292 9.17691 24.3306 9.14141 24.6447 9.01716C25.0112 8.78637 25.9709 8.00532 24.6447 6.56747Z",
    fill: "#A98698"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8403 5.32496C21.1893 5.46697 21.643 5.71549 22.2015 6.08827C22.8646 6.53205 23.4405 7.02909 23.807 7.41961C23.1962 8.23615 22.7948 9.35449 22.5505 10.1356C22.6726 10.3131 22.8122 10.4906 22.9344 10.6681C23.0566 10.2243 23.266 9.56754 23.5452 8.9107C23.615 8.9285 23.7022 8.9285 23.7895 8.9285C23.9989 8.9285 24.2432 8.89295 24.4352 8.7332C24.5748 8.6267 24.7319 8.43145 24.7144 8.0764C24.7144 7.73914 24.4526 7.31311 23.9117 6.79832C23.5277 6.42554 23.0042 6.01726 22.4807 5.64449C20.9799 4.63266 19.9329 4.34864 19.4617 4.82792C19.1476 5.14745 19.1825 5.53798 19.2872 5.822C18.7288 6.19478 18.2576 6.46104 17.9435 6.63856C18.1529 6.70956 18.3448 6.79832 18.5543 6.88708C19.1127 6.58531 19.9154 6.07052 20.8403 5.32496ZM24.1385 7.8634C24.1909 7.95215 24.2083 8.04091 24.2083 8.09415C24.2083 8.2539 24.156 8.3072 24.1211 8.3427C24.0513 8.39595 23.9117 8.43145 23.7895 8.43145C23.8942 8.2184 24.0164 8.04091 24.1385 7.8634ZM19.8282 5.21846C19.8805 5.1652 20.0201 5.1297 20.247 5.1652C20.0725 5.30721 19.898 5.43147 19.7235 5.55573C19.706 5.43147 19.7235 5.30721 19.8282 5.21846Z",
    fill: "#5E12A0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3309 5.98245C8.62446 5.98245 4 10.6865 4 16.4912C4 22.2959 8.62446 27 14.3309 27C20.0373 27 24.6618 22.2959 24.6618 16.4912C24.6618 10.6865 20.0199 5.98245 14.3309 5.98245ZM14.3309 26.4142C8.93858 26.4142 4.57588 21.9763 4.57588 16.4912C4.57588 11.0061 8.93858 6.56824 14.3309 6.56824C19.7232 6.56824 24.0859 11.0061 24.0859 16.4912C24.0859 21.9763 19.7057 26.4142 14.3309 26.4142Z",
    fill: "#5E12A0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M14.33 26.4144C19.7175 26.4144 24.085 21.9717 24.085 16.4914C24.085 11.0111 19.7175 6.56845 14.33 6.56845C8.94242 6.56845 4.57495 11.0111 4.57495 16.4914C4.57495 21.9717 8.94242 26.4144 14.33 26.4144Z",
    fill: "url(#paint2_linear_4836_27799)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M14.2606 25.2071C8.93812 24.3373 5.32579 19.2427 6.19833 13.8286C6.58226 11.4322 7.76891 9.39074 9.44419 7.91739C7.00107 9.35524 5.18619 11.8582 4.69757 14.9114C3.84247 20.3255 7.4548 25.4202 12.7599 26.29C15.7265 26.787 18.5884 25.8462 20.7 24C18.8327 25.1006 16.5641 25.5799 14.2606 25.2071Z",
    fill: "#A98698"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M15.8845 6.70966C13.4239 6.30138 11.0332 6.86943 9.07863 8.12978C9.04373 8.16528 9.00883 8.20078 9.00883 8.20078C9.75922 7.73924 10.8586 7.33096 10.8586 7.33096C8.0316 8.99957 7.15906 10.8989 7.15906 10.8989C8.25846 8.73332 11.4869 7.2067 14.0172 7.10019C16.5476 6.99368 18.2054 7.75699 20.2297 9.40786C22.254 11.0765 23.4756 14.4847 23.3534 17.1829C23.2487 19.8811 21.8526 22.0645 21.8526 22.0645C22.8124 20.8042 23.3883 19.8811 23.7548 18.9403C23.8246 18.6563 23.8944 18.3723 23.9293 18.0705C24.8019 12.6741 21.2069 7.57948 15.8845 6.70966Z",
    fill: "url(#paint3_linear_4836_27799)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.598 16.4021C23.598 21.6032 19.4447 25.828 14.3316 25.828C9.21847 25.828 5.04773 21.6032 5.04773 16.4021H23.598Z",
    fill: "url(#paint4_linear_4836_27799)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M22.8646 16.4026C22.8646 21.4795 18.9208 25.6333 13.9647 25.8286C14.0869 25.8286 14.209 25.8286 14.3312 25.8286C19.4443 25.8286 23.5976 21.6038 23.5976 16.4026H22.8646Z",
    fill: "url(#paint5_linear_4836_27799)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M6.35678 16.4026H5.04797C5.04797 21.6038 9.20127 25.8286 14.3144 25.8286C14.5412 25.8286 14.7506 25.8286 14.9601 25.8108C10.1611 25.4558 6.35678 21.373 6.35678 16.4026Z",
    fill: "url(#paint6_linear_4836_27799)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5805 16.491C23.5805 15.4082 21.7307 14.7869 19.2702 14.5739C17.4902 14.4319 15.6927 14.6094 13.6335 15.2484C11.8535 15.781 10.2481 15.6922 9.07888 15.5502C6.47869 15.2484 5.04773 15.2129 5.04773 16.491C5.04773 18.3372 8.7473 20.6448 14.2967 19.846C17.1062 19.4377 18.5547 18.6035 20.2125 18.0354C22.0099 17.4319 23.5805 17.4496 23.5805 16.491Z",
    fill: "url(#paint7_linear_4836_27799)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3676 12.0168C18.235 12.0168 18.9382 11.3015 18.9382 10.4191C18.9382 9.53679 18.235 8.8215 17.3676 8.8215C16.5002 8.8215 15.797 9.53679 15.797 10.4191C15.797 11.3015 16.5002 12.0168 17.3676 12.0168Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9328 13.2064C20.299 13.2064 20.5959 12.9044 20.5959 12.5318C20.5959 12.1593 20.299 11.8573 19.9328 11.8573C19.5665 11.8573 19.2697 12.1593 19.2697 12.5318C19.2697 12.9044 19.5665 13.2064 19.9328 13.2064Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M22.3078 9.14221C22.2904 9.14221 22.2729 9.14221 22.2729 9.14221C22.1682 9.12446 22.0984 9.01796 22.1158 8.89366C22.2729 8.07712 22.936 7.29606 22.9709 7.26056C23.0408 7.1718 23.1804 7.1718 23.2502 7.24281C23.3374 7.31382 23.3374 7.45583 23.2676 7.52683C23.2502 7.54458 22.6394 8.27237 22.4998 8.98241C22.4823 9.08896 22.3951 9.14221 22.3078 9.14221Z",
    fill: "url(#paint8_linear_4836_27799)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.6868 23.8938C13.9566 23.8938 14.1754 23.6713 14.1754 23.3968C14.1754 23.1223 13.9566 22.8997 13.6868 22.8997C13.4169 22.8997 13.1981 23.1223 13.1981 23.3968C13.1981 23.6713 13.4169 23.8938 13.6868 23.8938Z",
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M13.4072 23.7168C13.2153 23.5215 13.2153 23.202 13.4072 23.0068C13.4421 22.9713 13.477 22.9535 13.5119 22.918C13.4421 22.9358 13.3898 22.9713 13.3374 23.0245C13.1455 23.2198 13.1455 23.5393 13.3374 23.7346C13.4945 23.8943 13.7388 23.9298 13.9308 23.8233C13.7562 23.8943 13.5468 23.8588 13.4072 23.7168Z",
    fill: "url(#paint9_linear_4836_27799)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13.8596 23.254C13.9174 23.254 13.9643 23.2064 13.9643 23.1475C13.9643 23.0887 13.9174 23.041 13.8596 23.041C13.8017 23.041 13.7549 23.0887 13.7549 23.1475C13.7549 23.2064 13.8017 23.254 13.8596 23.254Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.2341 23.6447C16.504 23.6447 16.7227 23.4222 16.7227 23.1477C16.7227 22.8732 16.504 22.6507 16.2341 22.6507C15.9643 22.6507 15.7455 22.8732 15.7455 23.1477C15.7455 23.4222 15.9643 23.6447 16.2341 23.6447Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M15.9553 23.4682C15.7634 23.273 15.7634 22.9534 15.9553 22.7582C15.9902 22.7227 16.0251 22.7049 16.06 22.6694C15.9902 22.6872 15.9379 22.7227 15.8855 22.7759C15.6936 22.9712 15.6936 23.2907 15.8855 23.486C16.0426 23.6458 16.2869 23.6813 16.4789 23.5747C16.3043 23.6458 16.0949 23.6102 15.9553 23.4682Z",
    fill: "url(#paint10_linear_4836_27799)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M16.4069 23.007C16.4647 23.007 16.5116 22.9593 16.5116 22.9005C16.5116 22.8417 16.4647 22.794 16.4069 22.794C16.3491 22.794 16.3022 22.8417 16.3022 22.9005C16.3022 22.9593 16.3491 23.007 16.4069 23.007Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.9768 24.7985C15.1792 24.7985 15.3432 24.6316 15.3432 24.4257C15.3432 24.2198 15.1792 24.0529 14.9768 24.0529C14.7744 24.0529 14.6104 24.2198 14.6104 24.4257C14.6104 24.6316 14.7744 24.7985 14.9768 24.7985Z",
    fill: "white"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M14.7676 24.6552C14.628 24.5132 14.628 24.2647 14.7676 24.1227C14.7851 24.105 14.82 24.0872 14.8374 24.0695C14.7851 24.0872 14.7502 24.1227 14.7153 24.1582C14.5757 24.3002 14.5757 24.5487 14.7153 24.6907C14.8374 24.815 15.0119 24.8327 15.169 24.744C15.0294 24.7972 14.8723 24.7617 14.7676 24.6552Z",
    fill: "url(#paint11_linear_4836_27799)"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M15.0997 24.3017C15.1383 24.3017 15.1695 24.2699 15.1695 24.2307C15.1695 24.1915 15.1383 24.1597 15.0997 24.1597C15.0612 24.1597 15.0299 24.1915 15.0299 24.2307C15.0299 24.2699 15.0612 24.3017 15.0997 24.3017Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.2277 24.5327C17.4301 24.5327 17.5941 24.3658 17.5941 24.1599C17.5941 23.954 17.4301 23.7871 17.2277 23.7871C17.0253 23.7871 16.8612 23.954 16.8612 24.1599C16.8612 24.3658 17.0253 24.5327 17.2277 24.5327Z",
    fill: "white"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M17.0174 24.3904C16.8778 24.2484 16.8778 23.9999 17.0174 23.8579C17.0348 23.8401 17.0697 23.8224 17.0872 23.8046C17.0348 23.8224 16.9999 23.8579 16.9651 23.8934C16.8255 24.0354 16.8255 24.2839 16.9651 24.4259C17.0872 24.5502 17.2617 24.5679 17.4187 24.4792C17.2791 24.5324 17.1221 24.4969 17.0174 24.3904Z",
    fill: "url(#paint12_linear_4836_27799)"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M17.3496 24.0349C17.3881 24.0349 17.4194 24.0031 17.4194 23.9639C17.4194 23.9247 17.3881 23.8929 17.3496 23.8929C17.311 23.8929 17.2798 23.9247 17.2798 23.9639C17.2798 24.0031 17.311 24.0349 17.3496 24.0349Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.6085 23.7156C12.0518 23.7156 12.4112 23.35 12.4112 22.899C12.4112 22.448 12.0518 22.0824 11.6085 22.0824C11.1652 22.0824 10.8058 22.448 10.8058 22.899C10.8058 23.35 11.1652 23.7156 11.6085 23.7156Z",
    fill: "white"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M11.1556 23.4154C10.8415 23.0959 10.8415 22.5811 11.1556 22.2616C11.2079 22.2083 11.2603 22.1728 11.3301 22.1373C11.2254 22.1728 11.1381 22.2438 11.0509 22.3148C10.7368 22.6344 10.7368 23.1491 11.0509 23.4687C11.3126 23.7349 11.714 23.7882 12.0281 23.5929C11.7315 23.7172 11.3824 23.6639 11.1556 23.4154Z",
    fill: "url(#paint13_linear_4836_27799)"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M11.889 22.6499C11.9853 22.6499 12.0635 22.5704 12.0635 22.4724C12.0635 22.3743 11.9853 22.2949 11.889 22.2949C11.7926 22.2949 11.7145 22.3743 11.7145 22.4724C11.7145 22.5704 11.7926 22.6499 11.889 22.6499Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.7812 21.7105C19.2246 21.7105 19.5839 21.3449 19.5839 20.8939C19.5839 20.4429 19.2246 20.0773 18.7812 20.0773C18.3379 20.0773 17.9785 20.4429 17.9785 20.8939C17.9785 21.3449 18.3379 21.7105 18.7812 21.7105Z",
    fill: "white"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M18.3094 21.407C17.9953 21.0875 17.9953 20.5727 18.3094 20.2532C18.3618 20.1999 18.4141 20.1644 18.4839 20.1289C18.3792 20.1644 18.292 20.2354 18.2047 20.3064C17.8906 20.6259 17.8906 21.1407 18.2047 21.4603C18.4665 21.7265 18.8678 21.7798 19.182 21.5845C18.8853 21.7088 18.5537 21.6555 18.3094 21.407Z",
    fill: "url(#paint14_linear_4836_27799)"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M19.0596 20.6438C19.156 20.6438 19.2342 20.5643 19.2342 20.4663C19.2342 20.3682 19.156 20.2888 19.0596 20.2888C18.9633 20.2888 18.8851 20.3682 18.8851 20.4663C18.8851 20.5643 18.9633 20.6438 19.0596 20.6438Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4836_27799",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.1295 6.26621) scale(7.79952 7.93381)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6807,
    stopColor: "#A087C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10002F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4836_27799",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.7886 9.64937) scale(19.0826 19.4112)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6807,
    stopColor: "#A087C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10002F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4836_27799",
    x1: 12.7652,
    y1: 26.2736,
    x2: 15.9909,
    y2: 6.71016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6202,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4836_27799",
    x1: 21.2061,
    y1: 9.75161,
    x2: 13.0139,
    y2: 17.1409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4836_27799",
    x1: 5.05558,
    y1: 21.1095,
    x2: 23.5935,
    y2: 21.1095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0002E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9952,
    stopColor: "#FF00C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4836_27799",
    x1: 24.4706,
    y1: 17.2297,
    x2: 14.2182,
    y2: 26.7549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4836_27799",
    x1: 5.05582,
    y1: 21.1101,
    x2: 14.9735,
    y2: 21.1101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9952,
    stopColor: "#7D00C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4836_27799",
    x1: 5.06802,
    y1: 17.2741,
    x2: 23.581,
    y2: 17.2741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9952,
    stopColor: "#BE00C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4836_27799",
    x1: 23.2785,
    y1: 7.17411,
    x2: 21.9147,
    y2: 9.35271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4836_27799",
    x1: 13.193,
    y1: 23.4125,
    x2: 13.9313,
    y2: 23.4125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4836_27799",
    x1: 15.7393,
    y1: 23.1606,
    x2: 16.4776,
    y2: 23.1606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4836_27799",
    x1: 14.6083,
    y1: 24.4287,
    x2: 15.1626,
    y2: 24.4287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4836_27799",
    x1: 16.8505,
    y1: 24.1632,
    x2: 17.4048,
    y2: 24.1632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4836_27799",
    x1: 10.8073,
    y1: 22.9214,
    x2: 12.013,
    y2: 22.9214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4836_27799",
    x1: 17.9678,
    y1: 20.9124,
    x2: 19.1736,
    y2: 20.9124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOsmosis);
export default __webpack_public_path__ + "static/media/osmosis.e48075365ba5f285c7c018334b2a1819.svg";
export { ForwardRef as ReactComponent };